module.exports = __webpack_public_path__ + "img/20210830_145310.28a5c896.jpg";